import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, ShieldCheck, XCircle } from "lucide-react";
import { Brand } from "@/components/Brand";
import { FundingDisclosure } from "@/components/FundingDisclosure";

import { api } from "@/lib/api";

export default function Verify() {
  const { id } = useParams();
  const [b, setB] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get(`/verify/${id}`).then((r) => setB(r.data)).catch(() => setErr(true)); }, [id]);
  return (
    <div className="min-h-screen grid-bg flex flex-col items-center justify-center p-6">
      <div className="mb-8"><Brand /></div>
      <div className="bg-white border-2 border-amber-400 rounded-lg p-10 max-w-lg w-full text-center shadow-xl" data-testid="verify-certificate">
        {err ? <><XCircle className="h-12 w-12 text-red-500 mx-auto" /><h1 className="font-display text-2xl font-extrabold mt-4" data-testid="verify-not-found">Certificate not found</h1></> : !b ? <Loader2 className="h-6 w-6 animate-spin text-emerald-600 mx-auto" /> : (
          <>
            <ShieldCheck className={`h-14 w-14 mx-auto ${b.valid ? "text-amber-500" : "text-slate-400"}`} />
            <div className="font-mono text-xs uppercase tracking-[0.2em] text-amber-700 mt-4">Peer Verified compliance certificate</div>
            <h1 className="font-display text-3xl font-extrabold text-slate-900 mt-3" data-testid="verify-company">{b.company}</h1>
            <p className="text-slate-600 mt-2">{[b.entity_type, b.industry, b.state].filter(Boolean).join(" · ")}</p>
            <p className="text-sm text-slate-600 mt-6 leading-relaxed">This business completed its state licensing path and had a grant proposal approved by a certified human editor in the Peer Verify LLC network.</p>
            <div className="mt-6 grid grid-cols-2 gap-4 text-sm border-t border-slate-200 pt-6">
              <div><div className="font-mono text-[10px] uppercase text-slate-400">Certificate ID</div><div className="font-semibold">{b.badge_id}</div></div>
              <div><div className="font-mono text-[10px] uppercase text-slate-400">Status</div><div className={`font-semibold ${b.valid ? "text-emerald-600" : "text-red-600"}`} data-testid="verify-status">{b.valid ? "Valid" : "Expired / revoked"}</div></div>
              <div><div className="font-mono text-[10px] uppercase text-slate-400">Issued</div><div>{new Date(b.issued_at).toLocaleDateString()}</div></div>
              <div><div className="font-mono text-[10px] uppercase text-slate-400">Valid until</div><div>{b.expires_at}</div></div>
            </div>
          </>
        )}
      </div>
      <FundingDisclosure className="max-w-2xl mt-8 text-center" />
    </div>
  );
}
